import React, { FC, useCallback, useEffect, useRef } from 'react'
import NonFlexingContainer from '@sport1/news-styleguide/NonFlexingContainer'
import useSkyAdSize from '@/utils/ads/hooks/useSkyAdSize'
import { blockedFormats } from '@/utils/ads/hooks/constants'

export type DisplaySkyAdProps = {
    placement?: string
    placementId?: string
    visibleBreadCrumbs: boolean
    isLeftSky?: boolean
}

const DisplaySkyAd: FC<DisplaySkyAdProps> = ({
    placement,
    placementId,
    visibleBreadCrumbs,
    isLeftSky = false,
}) => {
    const ref = useRef<HTMLDivElement>(null)
    const loaded = useRef(false)
    const { showSkyAd, isFullSkyAd } = useSkyAdSize(isLeftSky)
    const currentStatus = useRef(isFullSkyAd)

    const unregisterSkyAd = useCallback(() => {
        if (ref.current && placementId) {
            window.SDG?.cmd.push(function () {
                window.SDG?.Publisher?.unregisterSlot?.(placementId, true)
                loaded.current = false
                window.S1RegisteredSlots = window.S1RegisteredSlots || {}
                window.S1RegisteredSlots[placementId] = false
            })
        }
    }, [placementId])

    const registerSkyAd = useCallback(() => {
        if (ref.current && !loaded.current && placementId) {
            window.SDG?.cmd.push(function () {
                window.S1RegisteredSlots = window.S1RegisteredSlots || {}
                if (!window.S1RegisteredSlots[placementId]) {
                    window.S1RegisteredSlots[placementId] = true
                    const slot = window.SDG?.Publisher?.registerSlot?.(
                        placementId,
                        ref.current as HTMLDivElement
                    )
                    if (!isFullSkyAd) {
                        // remove 300px ads
                        slot?.blockFormats?.(blockedFormats)
                    }
                    slot?.load?.()
                }
                loaded.current = true
            })
        }
    }, [placementId, isFullSkyAd])

    useEffect(() => {
        if (showSkyAd) {
            if (currentStatus.current !== isFullSkyAd) {
                unregisterSkyAd()
                currentStatus.current = isFullSkyAd
            }
            registerSkyAd()
        } else {
            unregisterSkyAd()
        }
    }, [showSkyAd, isFullSkyAd, registerSkyAd, unregisterSkyAd])

    return (
        <NonFlexingContainer
            marginLeft={isLeftSky ? undefined : '24px'}
            marginRight={isLeftSky ? '24px' : undefined}
            className={`s1-ad-sky-${isLeftSky ? 'left' : 'right'}-container`}
        >
            <div
                data-testid={placement}
                ref={ref}
                className={`s1-ad s1-ad-name-${placement} s1-ad-${placementId} text-center`}
                style={{
                    width: '100%',
                    maxWidth: '100%',
                    marginTop: visibleBreadCrumbs ? '152px' : '128px',
                }}
            >
                <div id={placementId}></div>
            </div>
        </NonFlexingContainer>
    )
}

export default DisplaySkyAd
